/** Enum para los roles de usuario a nivel de entidad */
export enum RolEnum {
    /** Usuario con rol de Administrador de una entidad */
    Administrador = 1,
    /** Usuario con rol de Abogado. Puede ser miembro de una entidad  */
    Abogado = 2,
    /** Usuario con rol de Paralegal. Puede ser miembro de una entidad */
    Paralegal = 3,
    /** Usuario con rol de Ministerio Público. Ministerio público es una entidad */
    MinisterioPublico = 4,
}

export enum TipoRolEnum {
  Administrador = 1,
  Abogado = 2,
  Paralegal = 3,
  MinisterioPublico = 4,
}

